import React, { useState, useEffect } from "react";
import "./Modalpopup.css"; // Import the CSS file
import { Logo1, Logo2 } from "../../Assests/Assests";
import { Link, useNavigate } from "react-router-dom";

const ModalPopup = () => {
  const [showModal, setShowModal] = useState(false);
  const [exclusiveProduct, setexclusiveProduct] = useState(null); // Ensure it's null by default
  const [loading, setLoading] = useState(false); // Loader state

  const navigate = useNavigate();

  let token = localStorage.getItem("userToken");

  useEffect(() => {
    if (token) {
      const fetchExclusiveProduct = async () => {
        try {
          const response = await fetch("https://riymay.com/api/v1/user/products");
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const data = await response.json();
          const product = data.products.find((product) => product.exclusive === true);
          if (product) {
            setexclusiveProduct(product); // Set the exclusive product if found
          }
        } catch (error) {
          console.error("Error fetching exclusive product:", error);
        }
      };

      fetchExclusiveProduct();
    }
  }, [token]);

  useEffect(() => {
    if (exclusiveProduct) {
      const timer = setTimeout(() => {
        setShowModal(true); // Show the modal after 5 seconds
      }, 5000);
      return () => clearTimeout(timer); // Cleanup the timer
    }
  }, [exclusiveProduct]);

  const handleClose = () => {
    setShowModal(false);
  };

  const handleNavigate = () => {
    navigate("/");
    setShowModal(false);
  };

  return (
    <>
      {showModal && exclusiveProduct && (
        <div className="exclusive-modal-overlay">
          <div className="exclusive-modal">
            {/* Modal Content */}
            <div className="exclusive-modal-grid">
              {/* Left Side */}
              <div className="exclusive-modal-content">
                <div className="exclusive-modal-logo-container">
                  {/* <img src={Logo1} alt="Left Logo" className="exclusive-modal-navbar-logo" /> */}
                  <img src={Logo2} alt="Main Logo" className="exclusive-modal-main-logo" />
                </div>
                <h2 className="exclusive-modal-title">🎉 New Arrival Alert!</h2>
                <p className="exclusive-modal-subtitle">Get the updates</p>
                <div className="exclusive-modal-form">
                  <p className="exclusive-modal-para">{exclusiveProduct.name}</p>
                  <p className="exclusive-modal-para">💥 Special Offer:</p>
                  <Link to="newproduct">
                    <button className="exclusive-modal-button" onClick={handleNavigate}>
                      Shop Now & Save Big!
                    </button>
                  </Link>
                </div>
                <button className="exclusive-modal-close" onClick={handleClose}>
                  No, Thanks
                </button>
              </div>

              {/* Right Side */}
              <div
                className="exclusive-modal-image"
                style={{
                  backgroundImage: `url(https://riymay.com/assets/${exclusiveProduct.images[0]?.url})`,
                }}
              ></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ModalPopup;
